export default function Tooltip({text, position = 'top'}) {
    const positions = {
        top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
        bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    }

    const arrows = {
        top: 'top-full left-1/2 -translate-x-1/2 border-t-[var(--bg-dark)] border-x-transparent border-b-transparent',
        bottom: 'bottom-full left-1/2 -translate-x-1/2 border-b-[var(--bg-dark)] border-x-transparent border-t-transparent',
    }

    return (
        <span className={`hopn-anim-tooltip hopn-anim-tooltip--${position} absolute ${positions[position]} bg-(--bg-dark) text-white text-xs px-3 py-1.5 rounded-lg whitespace-nowrap`}>
            {text}
            <span className={`absolute ${arrows[position]} border-[5px] w-0 h-0`}/>
        </span>
    )
}
